export class PayAway {
	id: number;

	payAwayPercentage: number;
	payAwayMinimumCommission: number;
	currencyId: number;
	currencyName: string;
	startDate: Date;
	endDate: Date;
}
